import { processAppMetaData } from 'bridge';
import { FLAG } from 'enums';
import { OK, PLATFORMS } from 'constants/general';
import { AppMetadataType } from 'interfaces';
import { addInstalledApps } from 'store/reducer/setting/slice';
import { getAppDispatch, getAppState } from 'store/store-access';

export const exposeHasUserModifiedSettings = () => {
  window.hasUserModifiedSettings = () => ({
    isUserSettingsModified:
      getAppState()?.setting.isUserSettingsModified ?? false
  });
};

export const exposeloadSettingsData = () => {
  window.loadSettingsData = (data: AppMetadataType) => {
    //@Description: provides only a simple mode for mobile applications
    const metaData = {
      ...data,
      flags: [PLATFORMS.ANDROID, PLATFORMS.IOS, PLATFORMS.MOB].includes(
        data.platform ?? ''
      )
        ? [
            ...(data?.flags ?? []).filter((flag) => flag !== FLAG.GEEK_MODE),
            FLAG.SIMPLE_MODE
          ]
        : data.flags
    };
    processAppMetaData(metaData);
  };

  window.LoadInstalledApps = (data: { installedApps: string[] }): string => {
    getAppDispatch()?.(addInstalledApps(data));
    return OK;
  };

  window.refreshSettingPage = () => {
    window.location.reload();
  };
};
